module.exports = __webpack_public_path__ + "static/media/extact-lappy.f3359752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/extact-lappy.jpg
// module id = 96
// module chunks = 0